import React, { FC, useEffect } from 'react';
import './index.scss';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { useIntl } from 'umi'

const CalculationBubble = (porps: any) => {
  let { 
    tipList,
    isLoading = false,
  } = porps;

  const isCalculating = tipList.some(
    (tip: any) => {
      return tip.hasData === false
    }) 
    || isLoading;

  return (
    <Bubble
      className="dbd-calculation-bubble"
      dark
    //   trigger={'click'}
      content={<ItemTip tipList={tipList} isLoading={isLoading} />}
    >
      {/* 添加 action 类名 是要正在计算 */}
      <div className={`dbd-calculation-icon ${isCalculating ? 'action' : ''}`}>
        <SvgIcon type="calculatin" />
      </div>
    </Bubble>
  );
};

export default CalculationBubble;

const ItemTip: FC<any> = ({ tipList, isLoading }) => {
  const { formatMessage } = useIntl()
  
  return (
    <div className="dbd-calculation-bubble-box">
      <div className="dbd-calculation-bubble-title">
        {formatMessage({ id: 'data_calculation_specification' })}
      </div>
      {tipList?.map((tip: any, index: number) => {
        const isCompleted = !isLoading && tip.hasData;
        return (
          <div
            className={`dbd-calculation-bubble-item ${
              isCompleted ? '' : 'disable'
            }`}
            key={tip.title + index}
          >
            <img src={tip.icon} className="dbd-calculation-bubble-icon" />
            {(isCompleted) ? 
              formatMessage({ id: 'bubble_completed' }) 
              : formatMessage({ id: 'bubble_calculating' })
            }
          </div>
        );
      })}
    </div>
  )
};
